import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Extracts username/handle from a social media URL or returns the handle if already provided
 * @param url - Full URL (e.g., https://twitter.com/johndoe) or just username (e.g., johndoe)
 * @returns The extracted username without @ prefix
 */
export function extractSocialHandle(url: string | undefined): string | undefined {
  if (!url) return undefined

  // If it's already just a username (no slashes), return it
  if (!url.includes("/")) return url

  try {
    const urlObj = new URL(url.startsWith("http") ? url : `https://${url}`)
    const path = urlObj.pathname.replace(/^\/+|\/+$/g, "") // Remove leading/trailing slashes
    return path || undefined
  } catch {
    return url
  }
}
